import { ComponentType, FC, ReactElement, useState } from 'react'
import ListItem from '../ListItem/ListItem';
import { useIntl } from 'react-intl';

export type SettingsItemProps = {
  icon: ReactElement;
  DrawerComponent: ComponentType<{ open: boolean, onClose: () => void }>;
  title: string;
}

export const SettingsItem: FC<SettingsItemProps> = ({ icon, DrawerComponent, title }) => {
  const { formatMessage: t } = useIntl();
  const [open, setOpen] = useState(false);

  const onSelect = () => {
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  }

  return (
    <>
      <ListItem
        onSelect={onSelect}
        icon={icon}
        title={t({ id: title })}
      />
      <DrawerComponent open={open} onClose={onClose} />
    </>
  )
}